import { ItemRenderProps, TreeView, TreeViewExpandChangeEvent, TreeViewItemClickEvent } from '@progress/kendo-react-treeview'
import { getName } from '../helpers/helperMethods';
import { DataModel } from '../interfaces/FileManagerModels';
import {useRef, useState} from "react";
import {Button} from "@progress/kendo-react-buttons";
import * as React from "react";
import {Input} from "@progress/kendo-react-inputs";
import {classNames, SvgIcon} from '@progress/kendo-react-common';
import {TextField} from "@mui/material";
import {NavigatableMode} from "@progress/kendo-react-data-tools";

export const FolderTree = (props) => {
  const [editItem, setEditItem] = React.useState(null);
  const [renameValue, setRenameValue] = useState<string>('');
  const [isEditing, setIsEditing] = React.useState(false);

  var valueofinput = ''

  const handleInputChange = (e) => {
    console.log('handleInputChange')
    // debugger;
    // e.nativeEvent.preventDefault();
    // e.nativeEvent.stopPropagation();
    // console.log(e.target.value)
    setRenameValue(e.target.value)
    valueofinput = e.value
  }
  const handleEdit = (event: React.ChangeEvent<HTMLInputElement>, item: DataModel) => {
    props.onItemEdit({
      item,
      event
    });
  };

  const handleBlur = (event: React.ChangeEvent<HTMLInputElement>, item: DataModel) => {
    // props.onItemBlur({
    //   item,
    //   event
    // });
  };

  const handleExpandChange = (event: TreeViewExpandChangeEvent) => {
    debugger;
    props.onItemClick({
      item: event.item,
      event
    });
  };

  const handleItemClick2 = (event, item) => {
    // debugger;
    if (item) {
      // if (!item?.edit) {
        //   setEditItem(event.item);
        props.onItemClick({
          item: item,
          event
        });
      // }
    }
  };

  const handleItemClick = (event: TreeViewItemClickEvent) => {
    // event.nativeEvent.preventDefault();
    // event.nativeEvent.stopPropagation();

    if (event.item) {
      if (!event.item?.edit) {
      //   setEditItem(event.item);
        props.onItemClick({
          item: event.item,
          event
        });
      }
    }
  };

  const onSaveRename = (event, dataItem) => {
    setIsEditing(false)
    props.selectedItem.edit = false
    props.onSaveRename({
      event: event,
      dataItem: dataItem,
      value: renameValue
    });
  }

  const onCancelRename = (event, dataItem) => {
    props.selectedItem.edit = false
    dataItem.edit = false
    setIsEditing(false)
  }

  const handleContextMenu = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>, item: DataModel) => {
    event.stopPropagation()
    event.preventDefault()

    setEditItem(item);
    setRenameValue(props.selectedItem.name);
    // setEditItem(item);
    // console.log(props.selectedItem)
    // props.selectedItem.edit = true
    // item.edit = true;

    props.onContextMenu({
      tree: true,
      dataItem: props.selectedItem,
      istreeitem: true,
      event
    });
  };

  const TreeViewItem = (props) => {
    if (props.item?.edit) {
      setIsEditing(true)
      return (
        <div style={{width: '100%'}}>
          <Input
              // ref={inputRef}
              // maxLength={40}
              autoFocus
              id={props.item.id}
              defaultValue={renameValue}
              style={{width: '60%', marginRight: '5px'}}
              onKeyDown={(e) => e.stopPropagation()}
              className={'k-textbox'}
              onBlur={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              // onInput={handleInputChange}
              onChange={(e) => {
                console.log(e)
                handleInputChange(e);
                e.nativeEvent.stopPropagation();
                e.nativeEvent.preventDefault();

              }}
          />
          {/*<TextField style={{width: '60%', marginRight: '5px'}} id="outlined-basic" label="Outlined" variant="outlined"*/}
          {/*           onChange={handleInputChange}*/}
          {/*           defaultValue={renameValue}*/}
          {/*/>*/}
          <Button
              themeColor={'primary'}
              style={{width: '15%', marginRight: '5px'}}
              onClick={(e) => onSaveRename(e, props.item)}
          >
            {'Save'}
          </Button>
          <Button
              themeColor={'primary'}
              style={{width: '15%'}}
              onClick={(e) => onCancelRename(e, props.item)}
          >
            {'Cancel'}
          </Button>
        </div>
      );
    }
    else {
      setIsEditing(false)
      const name = getName(props.item.path);
      return (
          <span onContextMenu={(event) => handleContextMenu(event, props.item)}>{name}</span>
      );
    }
  };

  return (

    <TreeView
      data={props.data}
      item={TreeViewItem}
      className="k-filemanager-treeview"
      textField="id"
      expandIcons={true}
      onExpandChange={handleExpandChange}
      onItemClick={handleItemClick}
    />
  );
}
